var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"row no-gutters",staticStyle:{"height":"2000px"}},[_vm._v(" 404 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }